import React from "react";
import { Route } from "react-router-dom";
import SurveyPageSkeleton from "./components/pages/SurveyPageSkeleton";
import Header from "./components/Header";
import SummaryPageSkeleton from "./components/pages/SummaryPageSkeleton";
import LandingPageSkeleton from "./components/pages/LandingPageSkeleton";

const AppLoading = ({ isLandingPage }) => {
  return (
    <div className="app app-content-container app--loading">
      {!isLandingPage && <Header />}
      <div className="pageContainer">
        <Route exact={true} path="/guide" component={LandingPageSkeleton} />
        <Route
          path="/guide/spa/:uuid/:path/:page"
          component={SurveyPageSkeleton}
        />
        <Route path="/guide/:uuid/summary" component={SummaryPageSkeleton} />
        <Route path="/guide/:uuid/details" component={SummaryPageSkeleton} />
      </div>
    </div>
  );
};

export default AppLoading;
